import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Avatar,
  Box,
  Button,
  Heading,
  HStack,
  Text,
  VStack,
} from "@chakra-ui/react"
import React from "react"
import { MinusIcon } from "@chakra-ui/icons"

const accordionItems = (
  teams,
  onTeamSelect,
  handleAddMember,
  handleRemoveMember,
) => {
  if (!teams || !Array.isArray(teams)) return []
  return teams.map((team, index) => (
    <>
      <AccordionItem key={team.id}>
        <AccordionButton
          onClick={() => onTeamSelect(team.id, index)}
          margin="0em"
        >
          <Heading size="sm">{team.name}</Heading>
          <AccordionIcon />
        </AccordionButton>
        <AccordionPanel>
          <VStack width="100%">
            {team.members && team.members.length > 0 ? (
              team.members.map((member) => {
                const memberWithTeam = {
                  ...member,
                  in_team: [team.id],
                }
                return (
                  <HStack
                    width="100%"
                    key={member.id}
                    justifyContent="space-between"
                  >
                    <HStack>
                      <Avatar bg="Primary.500" height="1.25em" width="1.25em" />
                      <Text>{member.email}</Text>
                    </HStack>
                    <Button
                      maxH="1.25em"
                      maxW="1.25em"
                      minH="1.25em"
                      minW="1.25em"
                      padding="0"
                      bg="red.500"
                      color="white"
                      onClick={() => handleRemoveMember(memberWithTeam)}
                    >
                      <MinusIcon />
                    </Button>
                  </HStack>
                )
              })
            ) : (
              <Text>No members</Text>
            )}
          </VStack>
        </AccordionPanel>
      </AccordionItem>
    </>
  ))
}

export default function TeamEditor({
  editedTeams,
  setSelectedTeamId,
  handleAddMember,
  handleRemoveMember,
  selectedTeamId,
}) {
  const handleTeamSelect = (teamId) => {
    setSelectedTeamId(teamId)
  }

  const handleAccordionChange = (expandedIndex) => {
    if (expandedIndex === -1) {
      setSelectedTeamId(null)
    } else if (editedTeams && editedTeams[expandedIndex]) {
      setSelectedTeamId(editedTeams[expandedIndex].id)
    }
  }

  return (
    <Box
      justifyContent="center"
      alignItems="center"
      height="100%"
      overflowY="auto"
    >
      <Accordion
        variant="permissions"
        allowToggle
        onChange={handleAccordionChange}
      >
        <VStack spacing={2} width="100%">
          {accordionItems(
            editedTeams,
            handleTeamSelect,
            handleAddMember,
            handleRemoveMember,
            selectedTeamId,
          )}
        </VStack>
      </Accordion>
    </Box>
  )
}
